import { memo } from 'react'
import { camelCase } from '@pff-consumer/utils/lib/format/format'
import { Text, TextDescriptionVariant } from '../browser-text'
import type { LabelProps } from './label.props'
import { useStyles } from './label.web.styles'

export const Label = memo((props: LabelProps) => {
  const { label, isRequired } = props
  const styles = useStyles()

  return (
    <label
      htmlFor={label}
      data-testid={`label.${camelCase(label)}`}
    >
      <Text variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}>
        {label}
        {isRequired && <span className={styles.asterisk}>*</span>}
      </Text>
    </label>
  )
})
